import { MessageCircle, BookOpen, GraduationCap, Users, Wrench, NotebookPen } from 'lucide-react';
import type { JourneyItemType } from '../services/journeyTypes';
import Button from '../../../components/Button';

interface JourneyItemTypeSelectorProps {
    onSelect: (type: JourneyItemType) => void;
    onCancel: () => void;
}

interface JourneyItemTypeOption {
    type: JourneyItemType;
    icon: React.ReactNode;
    label: string;
}

const journeyItemTypeOptions: JourneyItemTypeOption[] = [
    {
        type: 'chat',
        icon: <MessageCircle size={24} />,
        label: 'Chat',
    },
    {
        type: 'check-in',
        icon: <NotebookPen size={24} />,
        label: 'Check-in',
    },
    {
        type: 'story',
        icon: <BookOpen size={24} />,
        label: 'Story',
    },
    {
        type: 'lesson',
        icon: <GraduationCap size={24} />,
        label: 'Lesson',
    },
    {
        type: 'community-question',
        icon: <Users size={24} />,
        label: 'Community Question',
    },
    {
        type: 'tool',
        icon: <Wrench size={32} />,
        label: 'Tool',
    },
];

export const JourneyItemTypeSelector = ({ onSelect, onCancel }: JourneyItemTypeSelectorProps) => {
    return (
        <div className="fixed inset-0 bg-gray-600/10 overflow-y-auto h-full w-full z-50 flex items-center justify-center p-4">
            <div className="relative mx-auto p-4 w-full max-w-lg shadow-lg rounded-md bg-white">
                <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">Select Item Type</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mb-2">
                    {journeyItemTypeOptions.map((option) => (
                        <button
                            key={option.type}
                            onClick={() => onSelect(option.type)}
                            className="flex flex-col items-center p-2 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all duration-200 text-center group"
                        >
                            <div className="text-gray-600 group-hover:text-blue-600 mb-1">
                                {option.icon}
                            </div>
                            <h4 className="font-semibold text-gray-900 text-sm">{option.label}</h4>
                        </button>
                    ))}
                </div>

                <div className="flex justify-end">
                    <Button
                        className="w-full"
                        onClick={onCancel}
                        variant="secondary"
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </div>
    );
};
